import { render, staticRenderFns } from "./addRongYu.vue?vue&type=template&id=437164e4&scoped=true"
import script from "./addRongYu.vue?vue&type=script&lang=js"
export * from "./addRongYu.vue?vue&type=script&lang=js"
import style0 from "./addRongYu.vue?vue&type=style&index=0&id=437164e4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "437164e4",
  null
  
)

export default component.exports